/**
 * Whether `LogRocket.init` has actually been called this session.
 *
 * `App.tsx`'s init condition (hostname, app ID, blacklist, and a fully-populated signed-in
 * user) is the real source of truth for "is an SDK instance running" — `errorReporting.ts`
 * used to duplicate only half of that condition, so reports were attempted against an SDK
 * that was never started for signed-out and excluded sessions. This module is the single flag
 * both sides read/write, kept dependency-free to avoid any import-cycle risk between
 * `App.tsx` and `errorReporting.ts`.
 */
let initialized = false;

export const markLogRocketInitialized = (): void => {
  initialized = true;
};

export const isLogRocketInitialized = (): boolean => initialized;
